import { ColorMode, LayoutPreset } from "@shared/config/layout.config";

export const WILL_CALL_DISPLAY_LABEL_MAP = {
  will_call: {
    id: "will_call",
    labelKey: "Will Call",
    key: "will_call",
  },
  pickup: {
    id: "pickup",
    labelKey: "Pickup",
    key: "pickup",
  },
} as const;

export type WillCallDisplayLabel = keyof typeof WILL_CALL_DISPLAY_LABEL_MAP;

export type BrandingConfigSerializer = {
  id: number;
  branding_body_font: string | null;
  branding_color_mode: ColorMode | null;
  branding_header_image: string | null;
  branding_heading_font: string | null;
  branding_logo: string | null;
  branding_primary_color: string | null;
  branding_secondary_color: string | null;
  branding_website_display_text: string | null;
  branding_website_url: string | null;
  branding_reply_to_email: string | null;
  branding_email_sender_name: string | null;
  branding_email_background_color: string | null;
  branding_will_call_display_label: WillCallDisplayLabel | null;
  has_branding_config: boolean;
  branding_layout_preset: LayoutPreset | null;
};

export type BrandingConfigWritePayload = Partial<BrandingConfigSerializer> & {
  model_type?: "venue" | "event" | "membership_group" | "website";
  instance_id?: number;
};
